import { render } from "./EditCreditNoteDetails.vue?vue&type=template&id=6b12da35"
import script from "./EditCreditNoteDetails.vue?vue&type=script&lang=js"
export * from "./EditCreditNoteDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__